

/**
 * axios二次封装
 */
import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '../router'
//  import storage from './storage'

const TOKEN_INVALID = 'Token认证失败，请重新登录'
const NETWORK_ERROR = '网络请求异常，请稍后重试'

// 创建axios实例对象，添加全局配置
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 5 * 60 * 1000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json; charset=utf-8'
    }
})

// 请求拦截
service.interceptors.request.use((req) => {
    // console.log(req)
    //  const headers = req.headers;
    //  const { token } = storage.getItem('fidInfo');
    if (localStorage.getItem('token')) req.headers.Authorization = localStorage.getItem('token')
    // 解决非配置页面报String contains non ISO-8859-1 code point错误 不添加mapconfigdata字段值 2025-03-28
    const hasLoginRoute = ['mapconfigv2', 'mapconfig', 'smconfig']
    const routeName = router.currentRoute.value.name
    if (localStorage.getItem('mapconfigdata') && hasLoginRoute.includes(routeName)) req.headers.Authorization = localStorage.getItem('mapconfigdata')
    return req;
})

// 响应拦截
service.interceptors.response.use((res) => {

    let resd = JSON.parse(JSON.stringify(res))
    res = res.data.objectid ? res : res.data
    if (typeof res === 'string') { return res }
    if (res.status === 40101) { return res }
    const { success, status, data, msg } = res;
    if (success || status === 200 || (data !== undefined && data.objectid !== undefined) || data.msg == '表单不存在') {
        return data || msg;
    } else if (success === 500001) {
        ElMessage.error(TOKEN_INVALID)
        setTimeout(() => {
            router.push('/login')
        }, 1500)
        return Promise.reject(TOKEN_INVALID)
    } else {
        // 地图 视频表单 无表单返回0
        if (resd.config.params.formId === 'video') {
            return { totalRow: 0 }
        }
        ElMessage.error(msg || data || NETWORK_ERROR)
        return Promise.reject(msg || data || NETWORK_ERROR)
    }
})
/**
 * 请求核心函数
 * @param {*} options 请求配置
 */
function request(options) {
    options.method = options.method || 'get'
    if (options.method.toLowerCase() === 'get') {
        options.params = options.data;
    }
    //  let isMock = process.env.VUE_APP_MOCK;
    //  console.log(isMock)
    //  if (typeof options.mock != 'undefined') {
    //      isMock = options.mock;
    //  }
    //  if (process.env.VUE_APP_NOTICE === 'prod') {
    //      service.defaults.baseURL = process.env.VUE_APP_BASE_URL
    //  } else {
    //      service.defaults.baseURL = isMock ? process.env.VUE_APP_MOCK_URL : process.env.VUE_APP_BASE_URL
    //  }
    service.defaults.baseURL = process.env.VUE_APP_BASE_URL

    return service(options)
}

['get', 'post', 'put', 'delete', 'patch'].forEach((item) => {
    request[item] = (url, data, options) => {
        return request({
            url,
            data,
            method: item,
            ...options
        })
    }
})

export default request;
